import React from 'react';
import { VictimsPageProvider } from '../../components/VictimsPageProvider';

export const HeroesBrigadesPage: React.FC = () => {
  return (
    <VictimsPageProvider isMilitary isBrigades />
  );
};
